module.exports = __webpack_public_path__ + "static/yes-logo-bf437f7163a70aa8043b6f0458d7eb40.png";